var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import TheLeftSidebarSection from "./section";
var TheLeftSidebar = (function (_super) {
    __extends(TheLeftSidebar, _super);
    function TheLeftSidebar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.user = _this.$store.state.user;
        _this.drawer = _this["$vuetify"].breakpoint.lgAndUp;
        _this.dark = false;
        _this.showMore = false;
        return _this;
    }
    TheLeftSidebar.prototype.toggleTheme = function () {
        var _this = this;
        this.dark = !this.dark;
        this.$nextTick(function () {
            _this.$emit('update:dark', _this.dark);
            localStorage.setItem('theme', _this.dark ? "dark" : "light");
        });
    };
    TheLeftSidebar.prototype.onDrawerChanged = function (newVal) {
        this["$store"].commit("setDrawer", newVal);
    };
    TheLeftSidebar.prototype.onRouteChange = function () {
        if (["xs", "sm", "md"].includes(this.$vuetify.breakpoint.name)) {
            this.drawer = false;
        }
    };
    TheLeftSidebar.prototype.created = function () {
        if (this["$vuetify"].breakpoint.lgAndUp) {
            this.drawer = this.$store.state.drawer;
        }
        this.dark = "dark" === localStorage.getItem('theme');
    };
    __decorate([
        Watch("drawer"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], TheLeftSidebar.prototype, "onDrawerChanged", null);
    __decorate([
        Watch("$route"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TheLeftSidebar.prototype, "onRouteChange", null);
    TheLeftSidebar = __decorate([
        Component({
            components: {
                "ls-section": TheLeftSidebarSection,
            },
        })
    ], TheLeftSidebar);
    return TheLeftSidebar;
}(Vue));
export default TheLeftSidebar;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/TheLeftSidebar/TheLeftSidebar.vue
// module id = 264
// module chunks = 0